export const addresses = {
  storeAddress: "0x449EBbdd48e598EeD989461515ace9A5887131D8",
  tokenAddress: "0x2A5edcf675AE15861F4af2aBCac20aB1296800fc",
};
